import { defineComponent, computed, openBlock, createElementBlock, normalizeClass, createElementVNode, normalizeStyle, toDisplayString, createCommentVNode, createBlock, resolveDynamicComponent, withCtx, createTextVNode, unref, createVNode } from "vue";
import { CdrButton, IconInformationStroke, IconQuestionFill } from "@rei/cedar";
const _hoisted_1 = {
  key: 0,
  "data-ui": "price-compare",
  class: "price-component__compare"
};
const _hoisted_2 = {
  id: "buy-box-product-price-compare",
  class: "price-component__compare--value"
};
const _hoisted_3 = {
  key: 0,
  class: "price-component__compare--range"
};
const _hoisted_4 = {
  class: "price-component__compare--value"
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  key: 1,
  class: "price-component__price-saving-percent"
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  key: 2
};
const _hoisted_10 = {
  key: 0,
  class: "price-component__percent-range"
};
const _hoisted_11 = {
  key: 1,
  id: "product-map-mesg",
  class: "product-price-map-message"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BuyBoxPrice",
  props: {
    price: {},
    displayPrice: {},
    styleOnSale: {
      type: Boolean,
      default: false
    },
    isAnyStyleOnSale: {
      type: Boolean,
      default: false
    },
    showCompare: {
      type: Boolean,
      default: false
    },
    showRange: {
      type: Boolean,
      default: false
    },
    showSaleRange: {
      type: Boolean,
      default: false
    },
    showPercentOffTest: {
      type: Boolean,
      default: false
    },
    showStylePriceSavingsPercent: {
      type: Boolean,
      default: false
    },
    showPercentOffSavings: {
      type: Boolean,
      default: false
    },
    flairBadge: {
      default: null
    }
  },
  emits: ["modalOpen", "openDisclaimerModal"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const priceWrapperTag = computed(() => props.price.hideDisplayPrice ? "del" : "span");
    const openMapModal = () => {
      const modalData = {
        label: "Why aren't we showing the price?",
        labelIsTitle: true,
        ariaDescribedBy: "description",
        modalContent: "MapMessageModal",
        id: "map-message-modal"
      };
      emit("modalOpen", modalData);
    };
    return (_ctx, _cache) => {
      var _a, _b;
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["price-component", {
          "price-component--flair": _ctx.flairBadge
        }]),
        "data-ui": "price-component-container"
      }, [createElementVNode("div", {
        class: normalizeClass({
          "price-component__price-wrapper": _ctx.flairBadge
        })
      }, [_ctx.flairBadge ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: "price-component--flair-title",
        style: normalizeStyle(((_a = _ctx.flairBadge) == null ? void 0 : _a.color) ? {
          color: _ctx.flairBadge.color
        } : null)
      }, toDisplayString(_ctx.flairBadge.title), 5)) : createCommentVNode("", true), createElementVNode("div", {
        class: normalizeClass(["price-component__price", {
          "price-component__price--flair": _ctx.flairBadge
        }]),
        style: normalizeStyle(((_b = _ctx.flairBadge) == null ? void 0 : _b.color) ? {
          "border": `1px solid ${_ctx.flairBadge.color}`
        } : null)
      }, [(openBlock(), createBlock(resolveDynamicComponent(priceWrapperTag.value), {
        id: "buy-box-price",
        class: "price-map-wrapper",
        "aria-label": _ctx.price.hideDisplayPrice ? "Old Price:" : ""
      }, {
        default: withCtx(() => [createElementVNode("span", {
          id: "buy-box-product-price",
          class: normalizeClass(["price-value", {
            "price-value--sale": _ctx.price.minPrice.sale
          }])
        }, " $" + toDisplayString(_ctx.displayPrice.min), 3), _ctx.showRange ? (openBlock(), createElementBlock("span", {
          key: 0,
          class: normalizeClass(["price-range", {
            "price-range--sale": _ctx.price.maxPrice.sale
          }])
        }, [_cache[1] || (_cache[1] = createTextVNode(" – ")), _cache[2] || (_cache[2] = createElementVNode("span", {
          class: "pdp-sr-only"
        }, "to", -1)), createTextVNode(" $" + toDisplayString(_ctx.displayPrice.max), 1)], 2)) : createCommentVNode("", true)]),
        _: 1
      }, 8, ["aria-label"])), _ctx.showCompare && !_ctx.price.hideDisplayPrice ? (openBlock(), createElementBlock("span", _hoisted_1, [_cache[5] || (_cache[5] = createElementVNode("span", {
        class: "pdp-sr-only"
      }, "Compared to ", -1)), createElementVNode("span", _hoisted_2, " $" + toDisplayString(_ctx.displayPrice.compare.min), 1), _ctx.price.minCompareAt.value !== _ctx.price.maxCompareAt.value ? (openBlock(), createElementBlock("span", _hoisted_3, [_cache[3] || (_cache[3] = createTextVNode(" - ")), _cache[4] || (_cache[4] = createElementVNode("span", {
        class: "pdp-sr-only"
      }, "to", -1)), createElementVNode("span", _hoisted_4, " $" + toDisplayString(_ctx.displayPrice.compare.max), 1)])) : createCommentVNode("", true), !_ctx.flairBadge ? (openBlock(), createElementBlock("span", _hoisted_5, "*")) : createCommentVNode("", true)])) : createCommentVNode("", true), _ctx.showPercentOffSavings ? (openBlock(), createElementBlock("span", _hoisted_6, [!_ctx.showCompare && (_ctx.showSaleRange || _ctx.displayPrice.savingsPercentMax) ? (openBlock(), createElementBlock("span", _hoisted_7, "Save up to " + toDisplayString(_ctx.displayPrice.savingsPercentMax) + "%", 1)) : createCommentVNode("", true), _ctx.displayPrice.savingsPercentage ? (openBlock(), createElementBlock("span", _hoisted_8, "Save " + toDisplayString(_ctx.displayPrice.savingsPercentage) + "%", 1)) : createCommentVNode("", true), _ctx.showStylePriceSavingsPercent ? (openBlock(), createElementBlock("span", _hoisted_9, [createTextVNode(" Save " + toDisplayString(_ctx.displayPrice.savingsPercentMin) + "% ", 1), _ctx.showCompare && _ctx.displayPrice.savingsPercentMax > _ctx.displayPrice.savingsPercentMin ? (openBlock(), createElementBlock("span", _hoisted_10, [_cache[6] || (_cache[6] = createElementVNode("span", {
        class: "pdp-sr-only"
      }, " to", -1)), createTextVNode("- " + toDisplayString(_ctx.displayPrice.savingsPercentMax) + "% ", 1)])) : createCommentVNode("", true)])) : createCommentVNode("", true)])) : createCommentVNode("", true), _ctx.showCompare && !_ctx.price.hideDisplayPrice ? (openBlock(), createBlock(unref(CdrButton), {
        key: 2,
        "icon-only": true,
        class: "disclaimer-btn",
        "data-ui": "disclaimer-btn",
        "aria-label": "More information about intermediate markdown",
        "aria-haspopup": "dialog",
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("openDisclaimerModal"))
      }, {
        icon: withCtx(() => [createVNode(unref(IconInformationStroke), {
          size: "small",
          class: "disclaimer-icon"
        })]),
        _: 1
      })) : createCommentVNode("", true)], 6), _ctx.price.hideDisplayPrice ? (openBlock(), createElementBlock("div", _hoisted_11, [_cache[7] || (_cache[7] = createTextVNode(" Add to cart to see price ")), createVNode(unref(CdrButton), {
        "icon-only": true,
        class: "smaller-icon",
        onClick: openMapModal
      }, {
        icon: withCtx(() => [createVNode(unref(IconQuestionFill), {
          class: "cdr-button__icon",
          "inherit-color": ""
        })]),
        _: 1
      })])) : createCommentVNode("", true)], 2)], 2);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=BuyBoxPrice2.mjs.map
